/* @flow */
// typecheck: ignore file
import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';

import { mountModal } from 'lib/modal';
import { pushRouterToChatWithMember } from 'lib/ChatRouteHelper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showRecent, hideRecent } from 'reducers/recentMessagesModal';
import ActivityStore from 'payments/stores/ActivityStore';
import AlertDialog from 'components/AlertDialog.jsx';
import AnnouncementThreadListItem from 'chat/components/AnnouncementThreadListItem.jsx';
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import ChatConstants from 'chat/constants/ChatConstants';
import ChatMessage from 'entities/ChatMessage';
import Chats from 'collections/Chats';
import ChatSearchBlock from 'chat/components/ChatSearchBlock.jsx';
import ChatStore from 'chat/stores/ChatStore';
import CurrentUser from 'auth/CurrentUser';
import { makeConversationFilter, makePeopleFilter } from 'chat/lib/ChatSearch';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import GroupStore from 'groups/stores/GroupStore';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import PotentialChatMembers from 'collections/PotentialChatMembers';
import PotentialChatMember from 'entities/PotentialChatMember';
import PromptStore from 'stores/PromptStore';
import QuickActionsBarContainer from './QuickActionsBarContainer.jsx';
import ScrollContainer from 'components/ScrollContainer.jsx';
import ScrollWatch from 'components/ScrollWatch.jsx';
import Text from 'components/Text.jsx';
import UniversalComposeButtonContainer from 'chat/containers/UniversalComposeButtonContainer.jsx';
import UnreadStore from 'stores/UnreadStore';
import isElementInViewport from 'utils/isElementInViewport';
import { rootGroup } from 'entities/RootGroup';
import { addStep } from 'reducers/joyrides';
import { AdminSignupRideInformation } from 'constants/rides';

import ChatListItem from './ChatListItem.jsx';
import ChatListSearchItem from './ChatListSearchItem.jsx';

import { TEACHER } from 'utils/roleHelpers';

import type { Target } from 'entities/Message';

import './styles/ChatList.scss';

type State = {
  allChatsLoaded: boolean,
  canSubscribersInitiateChats: boolean,
  chats: Chats,
  chatsAndSearchedChats: Chats,
  conversationResults: Chats,
  lastMessage: ?ChatMessage,
  peopleResults: PotentialChatMembers,
  potentialRecipients: PotentialChatMembers,
  newChatAvailable?: boolean,
  query: string,
  tooltip: boolean,
  updating: boolean,
  showQuickActions: boolean,
};

export const ChatList = React.createClass({
  propTypes: {
    selectedChatId: React.PropTypes.string,
    headerText: React.PropTypes.string,
    hideLocalChat: React.PropTypes.bool,
    group: React.PropTypes.instanceOf(Group).isRequired,
    showRecent: React.PropTypes.func.isRequired,
    hideRecent: React.PropTypes.func.isRequired,
    addStep: React.PropTypes.func.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
    chatSelectionAction: React.PropTypes.string,
  },

  mixins: [
    linkStateWithStores([ChatStore, UnreadStore, ActivityStore, PromptStore]),
  ],

  statics: {
    loadData() {
      ChatActions.loadPotentialChatMembers();
    },
  },

  getInitialState(): State {
    let canSubscribersInitiateChats = this.state ? this.state.canSubscribersInitiateChats : false;
    if (!canSubscribersInitiateChats) {
      const groups = GroupStore.getOwnedGroups();
      canSubscribersInitiateChats = groups.some(group => group.canSubscribersInitiateChats());
    }

    const { group } = this.props;
    const chats = ChatStore.getChats(group);
    const chatsAndSearchedChats = ChatStore.getChatsAndSearchedChats(group);
    const allChatsLoadedForGroup = ChatStore.areAllChatsLoadedForGroup(group);
    const showQuickActions = CurrentUser.inExpVariant('QUICK_ACTIONS', 'quick_actions');

    return {
      allChatsLoaded: allChatsLoadedForGroup,
      canSubscribersInitiateChats,
      chats,
      chatsAndSearchedChats,
      conversationResults: chats,
      lastMessage: null,
      peopleResults: ChatStore.getMembers(group),
      potentialRecipients: ChatStore.getMembers(rootGroup),
      query: '',
      tooltip: false,
      updating: false,
      showQuickActions,
    };
  },

  componentWillMount() {
    ChatList.loadData();

    // can't be defined in main property list because `this` is missing
    this.handleQueryChange = _.debounce(
       this.performSearch,
       ChatConstants.SEARCH_UI_LIMIT_MS,
       // lead so user gets immediate feedback when they start typing
       { leading: true, trailing: true }
     );
  },

  componentDidMount() {
    this.props.addStep(AdminSignupRideInformation.name, AdminSignupRideInformation.steps['joyride-send-a-message']);
  },

  // $FlowFixMe
  componentWillUpdate(nextProps) {
    const { group } = nextProps;
    if (group !== this.props.group) {
      this._searchBlock.handleClose();
      const chats = ChatStore.getChats(group);
      const chatsAndSearchedChats = ChatStore.getChatsAndSearchedChats(group);
      const allChatsLoadedForGroup = ChatStore.areAllChatsLoadedForGroup(group);

      this.setState({
        chats,
        conversationResults: chats,
        chatsAndSearchedChats,
        allChatsLoaded: allChatsLoadedForGroup,
        potentialRecipients: ChatStore.getMembers(rootGroup),
      });
    }
  },

  componentDidUpdate(prevProps: Object, prevState: Object) {
    if (this.state.query) {
      return;
    }

    const prevLastMessage = prevState.lastMessage;
    const { lastMessage } = this.state;

    // Scroll to the top when you send a chat message so that the current
    // thread is displayed at the top of the chat list
    if (prevLastMessage && lastMessage
      && prevLastMessage !== lastMessage
      && prevLastMessage.getChatId() !== lastMessage.getChatId()
      && lastMessage.getSender().id === CurrentUser.getUser().id) {
      this.scrollToTop();
    }

    this.loadMoreIfLoadingVisible();
  },

  // TODO move to an open-source scroll loader component.
  // spike in https://github.com/remind101/r101-frontend/pull/4140
  loadMoreIfLoadingVisible() {
    if (this._loadingIndicator) {
      const el = ReactDOM.findDOMNode(this._loadingIndicator);
      if (isElementInViewport(el)) {
        this.loadMoreChats();
      }
    }
  },

  getConversationResults(query: string) {
    if (!query) {
      return this.state.chats;
    }

    const f = makeConversationFilter(query);

    const matchingChats = this.state.chatsAndSearchedChats.filter(f);

    return new Chats(matchingChats);
  },

  getPeopleResults(query: string = '') {
    const f = makePeopleFilter(query);

    return this.state.potentialRecipients.filter(f);
  },

  getStateFromStores() {
    const { group } = this.props;
    const chats = ChatStore.getChats(group);
    return {
      chats,
      chat: ChatStore.getLocal(),
      newChatAvailable: chats.first() && !chats.first().getTitle(),
      lastMessage: chats.getLastMessage(),
      allChatsLoaded: ChatStore.areAllChatsLoaded(),
      conversationResults: this.state.query ? this.getConversationResults(this.state.query) : chats,
      potentialRecipients: ChatStore.getMembers(rootGroup),
      peopleResults: this.getPeopleResults(this.state.query),
    };
  },

  // Satisfy Flow
  handleQueryChange: () => null,
  _searchBlock: { handleClose: () => {} },

  // Fired upon clicking a chat thread
  handleChatClick() {
    ChatActions.setFocusView(ChatConstants.FocusableViews.COMPOSER);

    const leavingLocalChat = this.state.chats.first().isNew();
    if (leavingLocalChat) {
      ChatActions.destroyLocal();
    }
  },

  clearSearchQuery() {
    this.performSearch('');
  },

  // $FlowFixMe
  handlePersonSelection(member) {
    if (!member.isEligible()) {
      this.memberNotEligible(member);
      return;
    }

    pushRouterToChatWithMember(this.context.router, this.props.showRecent,
      this.props.hideRecent, member, this.props.group, () => {
        ChatActions.setFocusView(ChatConstants.FocusableViews.HEADER);
      });
    // Clear query after selection
    this.clearSearchQuery();
    this._searchBlock.handleClose();
  },

  // $FlowFixMe
  memberNotEligible(member) {
    let modal;
    if (member.isAgeUnknown() || member.isPending()) {
      if (member.isAgeUnknown()) {
        ChatActions.requestMemberAge(member);
      }

      modal = (
        <AlertDialog
          eventScreenName="ChatList"
          title="We need to collect more information from the participant"
          subtext="We'll notify you as soon as they're available for two-way messaging."
        />
      );
    } else if (member.isUnder13()) {
      modal = (
        <AlertDialog
          title="Two-way messaging is only available for students 13 and older."
          subtext="Don't worry—they can still receive announcements."
        />
      );
    } else if (member.isUnavailable()) {
      modal = (
        <AlertDialog
          title={`Sorry! ${member.getName()} isn't accepting messages on Remind.`}
        />
      );
    }

    if (modal) {
      mountModal(modal, this);
    }
  },

  performSearch(rawQuery: string = '') {
    const query = rawQuery.trim();

    this.setState({
      query,
      conversationResults: this.getConversationResults(query),
      peopleResults: this.getPeopleResults(query),
    }, () => {
      // TODO cache search queries for some amount of time
      // https://app.asana.com/0/42965143452863/116236888105435
      if (query.length > 0) {
        ChatActions.loadPotentialChatMembers(this.state.query);
        ChatActions.searchChats(this.state.query);
      }
    });
  },

  scrollToTop() {
    this.refs.scrollArea.scrollToTop();
  },

  renderConversations(chats: Chat[]) {
    return chats.map(chat => {
      return this.props.hideLocalChat && chat.isNew() ? null : this.renderConversationResult(chat);
    });
  },

  renderConversationResult(chat: Chat) {
    const { selectedChatId, group } = this.props;

    return (
      <ChatListItem
        key={chat.id || 'new'}
        chatUuid={chat.id}
        selected={chat.id === selectedChatId}
        group={group}
        query={this.state.query}
        onClick={this.handleChatClick}
      />
    );
  },

  loadMoreChats() {
    ChatActions.loadMoreChats(this.props.group);
  },

  _loadingIndicator: null,

  renderBody() {
    let loadingIndicator = null;
    const { group } = this.props;
    const { conversationResults, chats, peopleResults } = this.state;
    const hasChats = conversationResults.length > 0;
    const hasPeople = peopleResults.length > 0;
    const hasResults = hasChats || hasPeople;
    const canSendAnnouncements = !!group.getPostableRoles().length;

    const allChatsLoaded = ChatStore.areAllChatsLoadedForGroup(group);

    if (!this.state.query && !allChatsLoaded) {
      loadingIndicator = (
        <li>
          <ScrollWatch onEnter={this.loadMoreChats} threshold={0.2}>
            <div className="ChatList-loading">
              <LoadingIndicator size="small" ref={(r) => { this._loadingIndicator = r; }} />
            </div>
          </ScrollWatch>
        </li>
      );
    }

    if (this.state.query && !hasResults) {
      return (
        <div className="ChatList-noResults">
          <div className="ChatList-noResultsTitle">
            {'No results for "' + this.state.query + '"'}
          </div>
        </div>
      );
    }

    let body;
    const classHasChats = chats.length > 0;

    if (!canSendAnnouncements && !classHasChats) {
      body = (
        <ul className="ChatList-list">
          {this.renderEmpty()}
        </ul>
      );
    } else {
      body = (
        <ul className="ChatList-list">
          {!this.state.query && canSendAnnouncements && this.renderAnnouncementsConversationResults()}
          {!this.state.query && this.renderQuickActions()}
          {conversationResults.length > 0 && this.renderConversationsHeader()}
          {conversationResults.length > 0 && this.renderConversations(conversationResults.models)}
          {this.state.query && conversationResults.length > 0 && this.renderPeopleHeader()}
          {this.state.peopleResults.map(this.renderPersonResult)}
          {loadingIndicator}
        </ul>
      );
    }

    return (
      <ScrollContainer ref="scrollArea">
        {body}
      </ScrollContainer>
    );
  },

  renderAnnouncementsConversationResults() {
    const { group } = this.props;

    const threads: Target[] = group.getPostableThreads();
    const postableRoles = group.getPostableRoles();

    // Always display Teachers thread for staff classes to promote RBM
    if (group.isStaffClass() && !threads.some(t => t.role === TEACHER) && postableRoles.includes(TEACHER)) {
      threads.push({ role: TEACHER, group_id: group.id });
    }

    return (
      <div>
        {this.renderAnnouncementsHeader()}
        {threads.map((thread, i) =>
          <AnnouncementThreadListItem
            key={i}
            thread={thread}
            group={group}
            onClick={this.handleChatClick}
            isAnnouncementsThread
          />
        )}
      </div>
    );
  },

  renderEmpty() {
    const { group } = this.props;
    const isDistrict = group.getType() === 'district';
    return (
      <div>
        <div className="ChatList-list-header">
          Conversations
        </div>
        <UniversalComposeButtonContainer
          label="Start a conversation"
          hideActivities={isDistrict}
          level="secondary"
          full
        />
      </div>
    );
  },

  renderAnnouncementsHeader() {
    return (
      <div className="ChatList-list-header">
        Announcements
      </div>
    );
  },

  renderQuickActions() {
    if (!this.state.showQuickActions || this.props.group.isRoot()) {
      return null;
    }
    return <QuickActionsBarContainer group={this.props.group} />;
  },

  renderHeader() {
    const { group } = this.props;
    const isDistrict = group.getType() === 'district';
    return (
      <div ref="header" className="ChatList-header">
        <div className="ChatList-header-title">
          <h1>
            <Text size="large">
              {this.props.headerText || 'Messages'}
            </Text>
          </h1>
          <UniversalComposeButtonContainer
            className="joyride-send-a-message"
            label={<Glyph name="pencil-compose-stroke" size="xlarge" solo />}
            hideActivities={isDistrict}
          />
        </div>
        <ChatSearchBlock
          ref={ref => (this._searchBlock = ref)}
          className="ChatList-searchBlock"
          onDismiss={this.clearSearchQuery}
          onQueryChange={this.handleQueryChange}
        />
      </div>
    );
  },

  renderConversationsHeader() {
    return <div className="ChatList-list-header">Conversations</div>;
  },

  renderPeopleHeader() {
    return <div className="ChatList-list-header">People</div>;
  },

  renderPersonResult(member: PotentialChatMember) {
    if (this.state.query) {
      return (
        <ChatListSearchItem
          key={member.id}
          member={member}
          query={this.state.query}
          onSelect={this.handlePersonSelection}
        />
      );
    }
    return undefined;
  },

  render() {
    return (
      <div
        className={cx('ChatList', this.props.className)}>
        {this.renderHeader()}
        {this.renderBody()}
      </div>
    );
  },
});

function mapDispatchToProps (dispatch: Function) {
  return bindActionCreators({
    addStep,
    showRecent,
    hideRecent,
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ChatList);



// WEBPACK FOOTER //
// ./src/chat/components/ChatList.jsx